import { Card } from './ui/card';
import { X, Trophy, Flame, Star } from 'lucide-react';

export default function LiveLeaderboard({ supporters = [], onClose }) {
  return (
    <div className="fixed right-4 bottom-24 z-[85] w-72 animate-slide-in-right" data-testid="live-leaderboard">
      <Card className="bg-black/80 backdrop-blur-xl border-white/10 p-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-bold text-white flex items-center gap-2">
            <Trophy className="w-4 h-4 text-amber-400" />
            Top Supporters This Live
          </h3>
          <button onClick={onClose} className="text-white/40 hover:text-white/80 transition-colors" data-testid="leaderboard-close-btn">
            <X className="w-4 h-4" />
          </button>
        </div>

        {supporters.length === 0 ? (
          <p className="text-xs text-white/40 text-center py-4">No reactions yet. Be the first!</p>
        ) : (
          <div className="space-y-2">
            {supporters.map((s, i) => {
              const medals = ['🥇', '🥈', '🥉'];
              const medal = i < 3 ? medals[i] : null;

              return (
                <div
                  key={s.user_id}
                  className={`flex items-center gap-2.5 p-2 rounded-lg transition-colors ${
                    i === 0
                      ? 'bg-amber-500/10 border border-amber-500/20'
                      : i < 3
                      ? 'bg-white/5 border border-white/5'
                      : 'hover:bg-white/5'
                  }`}
                  data-testid={`leaderboard-entry-${i}`}
                >
                  {/* Rank */}
                  <div className="w-6 text-center shrink-0">
                    {medal ? (
                      <span className="text-lg">{medal}</span>
                    ) : (
                      <span className="text-xs text-white/30 font-mono">#{i + 1}</span>
                    )}
                  </div>

                  {/* Avatar */}
                  <div className="w-7 h-7 rounded-full bg-white/10 overflow-hidden shrink-0">
                    {s.avatar_url ? (
                      <img src={s.avatar_url} alt="" className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-xs font-bold text-white/50">
                        {(s.user_handle || '?')[0].toUpperCase()}
                      </div>
                    )}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-semibold text-white truncate">@{s.user_handle}</p>
                    <div className="flex items-center gap-2 text-[10px] text-white/40">
                      <span className="flex items-center gap-0.5">
                        <Flame className="w-2.5 h-2.5 text-orange-400" />
                        {s.reaction_count}
                      </span>
                      {s.super_count > 0 && (
                        <span className="flex items-center gap-0.5">
                          <Star className="w-2.5 h-2.5 text-amber-400" />
                          {s.super_count}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Impact */}
                  <div className="text-right shrink-0">
                    <p className="text-xs font-bold text-amber-400">+{s.total_weight}</p>
                    <p className="text-[9px] text-white/30">energy</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Card>
    </div>
  );
}
